export default defineNuxtPlugin(() => {
  if (!process.client) return
  if (!/iPhone/i.test(window.navigator.userAgent)) return

  let hasUserInteraction = false
  let guardActive = true

  const markUserInteraction = () => {
    hasUserInteraction = true
  }

  const disableGuard = () => {
    guardActive = false
  }

  window.addEventListener('pointerdown', markUserInteraction, { passive: true })
  window.addEventListener('keydown', markUserInteraction)
  window.addEventListener('touchstart', markUserInteraction, { passive: true })
  window.addEventListener('wheel', markUserInteraction, { passive: true })

  // Disable guard shortly after initial load to avoid affecting regular UX.
  window.addEventListener('load', () => {
    setTimeout(disableGuard, 1500)
  }, { once: true })

  // Hard fallback in case load is delayed by third-party scripts.
  setTimeout(disableGuard, 5000)

  const originalFocus = HTMLElement.prototype.focus
  HTMLElement.prototype.focus = function (...args: Parameters<HTMLElement['focus']>) {
    const isOneTrustBanner =
      this.id === 'onetrust-banner-sdk' ||
      this.classList?.contains('otFloatingRounded') ||
      this.classList?.contains('ot-sdk-container')

    if (isOneTrustBanner) {
      const options = args[0] || {}
      return originalFocus.call(this, { ...options, preventScroll: true })
    }

    if (!guardActive || hasUserInteraction) {
      return originalFocus.apply(this, args)
    }

    const options = args[0] || {}
    return originalFocus.call(this, { ...options, preventScroll: true })
  }
})
